import Utils from "../utils/utils";
import RequestManager from "./RequestManager";

const createNotificationTemplate = async (deploymentId, body) => {
    const response = await RequestManager.post({
        url: `/notificationTemplate/v1/${deploymentId}`,
        body
    });
    return response;
};

const getAllNotificationTemplate = async (deploymentId, size, firstCursor, lastCursor, prev, getLatest) => {
    const urlParams = Utils.getUrlParams({ size, prev, firstCursor, lastCursor, getLatest });

    const response = await RequestManager.get({
        url: `/notificationTemplate/v1/${deploymentId}${urlParams}`
    })
    return response.data;
};

const getNotificationTemplate = async (id) => {
    const response = await RequestManager.get({
        url: "/notificationTemplate/v1/" + id
    })
    return response;
};

const updateNotificationTemplate = async (deploymentId, id, body) => {
    const response = await RequestManager.put({
        url: `/notificationTemplate/v1/${deploymentId}/${id}`,
        body
    });
    return response;
}

const deleteNotificationTemplate = async (deploymentId, id) => {
    const response = await RequestManager.del({
        url: `/notificationTemplate/v1/${deploymentId}/${id}`
    });
    return response;
};

const NotificationTemplate = {
    createNotificationTemplate,
    getNotificationTemplate,
    getAllNotificationTemplate,
    updateNotificationTemplate,
    deleteNotificationTemplate
};

export default NotificationTemplate;